module.exports = __webpack_public_path__ + "static/img/ic_upload.448c7a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ic_upload.png
// module id = 1035
// module chunks = 1